/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Largeurl1Inputs */

const en_entity_largeurl1 = /** @type {(inputs: Entity_Largeurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large URL`)
};

const de_entity_largeurl1 = /** @type {(inputs: Entity_Largeurl1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Große URL`)
};

/**
* | output |
* | --- |
* | "Large URL" |
*
* @param {Entity_Largeurl1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_largeurl1 = /** @type {((inputs?: Entity_Largeurl1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Largeurl1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_largeurl1(inputs)
	return de_entity_largeurl1(inputs)
});
export { entity_largeurl1 as "entity_largeUrl" }